import MSI from "./MSI.js";
import { mod10, mod11 } from "./checksums.js";
class MSI1110 extends MSI {
  constructor(data, options) {
    data += mod11(data);
    data += mod10(data);
    super(data, options);
  }
}
var stdin_default = MSI1110;
export {
  stdin_default as default
};
